<template>
    <div>
        <div class="calculator-wrapper white contentCenter">
            <p class="carbon-text-sm text-center contentCenter">
                <span>{{ title }}</span>
                {{ subtitle }}
            </p>
            <div class="contentCenter">
                <label v-for="(option, index) in options" :key="index" class="optStyle" :for="'option_' + index">
                    <input type="radio" :id="'option_' + index" :value="option.val" v-model="picked">
                    {{ option.title }}
                </label>
            </div>
            <button class="calculateStyle" @click.prevent="submitResult">計算</button>
        </div>
    </div>
</template>

<script>
/* eslint-disable global-require */

export default {
    data() {
        return {
            picked: '',
        };
    },
    props: {
        title: {
            type: String,
            require: true,
            default: 'title',
        },
        subtitle: {
            type: String,
            require: true,
            default: 'subtitle',
        },
        options: {
            type: Array,
            require: true,
            default: () => [],
        },
    },
    methods: {
        submitResult() {
            this.$emit('get-result', this.picked);
        },
    },
};
</script>

<style scoped>
.optStyle {
    background-color: #B1DEF3;
    box-shadow: 5px 5px 10px rgb(99, 99, 99, 0.2);
    width: 300px;
    padding: 12px 24px;
    border-radius: 12px;
    display: flex;
    justify-content: flex-start;
    align-items: center;
    cursor: pointer;
}

input[type="radio"] {
    width: 30px;
    height: 30px;
    -webkit-appearance: none;
    appearance: none;
    border-radius: 50%;
    outline: none;
    box-shadow: 5px 5px 8px rgb(99, 99, 99, 0.2);
    background-color: rgb(255, 255, 255, 0.6);
    position: relative;
    margin-right: 32px;
}

input[type="radio"]::after {
    content: '';
    display: block;
    width: 15px;
    height: 15px;
    border-radius: 50%;
    background-color: #666666;
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    opacity: 0;
}

input[type="radio"]:checked::after {
    opacity: 1;
}

.calculateStyle {
    color: white;
    font-size: 20px;
    font-weight: 700;
    border-radius: 8px;
    background-color: #9AB76E;
    padding: 4px 56px;
    border: none;
    margin: 24px 0 8px 0;
}
</style>
